/**
 * ClientOptionsHost — sentinel mounted once at the app shell level (SP13.0).
 *
 * Subscribes to the launch-runtime bus and mounts <ClientOptionsDialog />
 * whenever a launch is active. Mirrors CalculatorHost.
 */
import { useSyncExternalStore } from 'react';
import { _clientOptionsRuntime } from './useClientOptions';
import { ClientOptionsDialog } from './ClientOptionsDialog';

export function ClientOptionsHost() {
  const state = useSyncExternalStore(
    _clientOptionsRuntime.subscribe,
    _clientOptionsRuntime.getSnapshot,
    _clientOptionsRuntime.getSnapshot,
  );

  if (!state.active) return null;

  return (
    <ClientOptionsDialog
      open
      onClose={() => _clientOptionsRuntime.setState({ active: null })}
      onSaved={state.active.onSaved}
    />
  );
}
